import React from 'react'

import SnackConsumer from './SnackConsumer'

export const withSnack = Component => React.forwardRef( ( props , ref ) =>
(
    <SnackConsumer>
        { store => <Component {...props} {...store} ref={ref} /> }
    </SnackConsumer>
));

export default withSnack ;